var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54397 20.1385C9.00984 13.8893 13.8893 9.00984 20.1385 7.54397C24.6516 6.48534 29.3484 6.48534 33.8615 7.54397C40.1107 9.00984 44.9902 13.8893 46.456 20.1385C47.5147 24.6516 47.5147 29.3484 46.456 33.8615C44.9902 40.1107 40.1107 44.9902 33.8615 46.456C29.3484 47.5147 24.6516 47.5147 20.1385 46.456C13.8893 44.9902 9.00984 40.1107 7.54397 33.8615C6.48534 29.3484 6.48534 24.6516 7.54397 20.1385Z",
    stroke: "#363853",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9774 23.0226L23.0225 30.9775M30.9774 30.9775L23.0225 23.0226",
    stroke: "#363853",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.f5b7a75b3adaea8fceddd19218d03212.svg";
export { ForwardRef as ReactComponent };